import CheckinSnackbar from '../../snackbar/components/CheckinSnackbar'
import CheckinModal from './modal/CheckinModal'
import { Grid } from '@mui/material'
import { CheckinPageProps } from '../../../pages/CheckinPage'
import { useStyles } from '../../../hooks/useStyles'
import { createLogger } from '../../../app/logger'
import CheckinPageContainer from './CheckinPageContainer'
import CheckinLoader from '../../../components/common/CheckinLoader'
import { CheckinPageDataTable } from './table/CheckinPageDataTable'
import { ChronoFilterTextField } from '../../filter/components/ChronoFilterTextField'
import QrComponent from '../../qr/components/QrComponent'
import ExportModifiedEntries from '../../../components/common/ExportModifiedEntries'
import { CheckinEntry } from '../../../app/types'

// eslint-disable-next-line no-unused-vars
export const logger = createLogger({
  prefix: 'CheckinPageContent'
})

export default function CheckinPageContent({
  data,
  ...props
}: CheckinPageProps & {
  data: CheckinEntry[]
}) {
  const { classes } = useStyles()

  return (
    <CheckinPageContainer
      data-cy={props['data-cy']}
      topLevel={<>
        <CheckinSnackbar />
        <CheckinModal data-cy={!props['data-cy'] ? undefined : `${props['data-cy']}-modal`} />
      </>}
      pageHeader={<>
        <CheckinLoader />
        <ExportModifiedEntries />
      </>}
      headerText={'Check-In Athletes'}
    >
      <QrComponent entries={data} />

      <Grid container item xs={12} justifyContent='right' className={classes.dataTable}>
        <Grid item lg={4}>
          <ChronoFilterTextField />
        </Grid>
        <CheckinPageDataTable data={data} />
      </Grid>

    </CheckinPageContainer>
  )
}
